import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-enable-disable-toggle',
  templateUrl: './enable-disable-toggle.component.html',
  styleUrls: ['./enable-disable-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EnableDisableToggleComponent),
      multi: true
    }
  ]
})
export class EnableDisableToggleComponent implements ControlValueAccessor {
  @Input() enableLabel = 'Enable';
  @Input() disableLabel = 'Disable';
  @Input() enabledLabel = 'Enabled';
  @Input() disabledLabel = 'Disabled';
  @Input() disabled = false;

  value: boolean = false;
  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  toggleValue(newValue: boolean): void {
    if (this.disabled) {
      return;
    }
    
    if (this.value !== newValue) {
      this.value = newValue;
      this.onChange(this.value);
      this.onTouched();
    }
  }
}
